import classNames from 'classnames';
import Label from './text/label';

interface RadioOptionProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label: string;
	labelClassName?: string;
}
const RadioOption = ({
	label,
	labelClassName,
	id,
	className,
	type,
	checked,
	...props
}: RadioOptionProps) => (
	<Label
		className={classNames(
			'flex items-center space-x-3 cursor-pointer gap-1 group w-fit',
			{
				'text-primary': checked,
			},
			labelClassName
		)}
		htmlFor={id}
	>
		<input
			className={classNames(
				'relative appearance-none w-4 h-4 text-primary border border-gray-border rounded-full cursor-pointer checked:border-primary checked:after:absolute checked:after:bg-primary checked:after:size-2 checked:after:rounded-full checked:after:top-1/2 checked:after:left-1/2 checked:after:-translate-x-1/2 checked:after:-translate-y-1/2',
				className
			)}
			id={id}
			type="radio"
			checked={checked}
			{...props}
		/>
		{label}
	</Label>
);

export default RadioOption;
